<!--
* 组件名 : 全部动画效果(为什么要有动画：动画能提升用户的体验，帮助用户更好的理解页面中的功能；)
* 开发者 : HN
*
* 参数:
* name         {String}  [fade]  - 动画类型  目前支持的动画类型："fade", "slideLeft", "slideRight"
*
* 事件:
* beforeEnter         [] - 进入之前
* enter               [] - 进入
* afterEnter          [] - 进入之后
* enterCancelled      [] - 进入取消
* beforeLeave         [] - 离开之前
* leave               [] - 离开
* afterleave          [] - 离开之后
*
-->
<template>
  <transition
    @before-enter="before_enter"
    @enter="enter"
    @after-enter="after_enter"
    @before-leave="before_leave"
    @leave="leave"
    @after-leave="after_leave"
    :css="false"
  >
    <slot />
  </transition>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { timeout } from "@/utils/util";
export default {
  name: "v-transition",
  props: {
    name: {
      type: String,
      default: "fade"
    }
  },
  data() {
    return {
      options: {
        duration: 3000, // 单位：ms(毫秒)
        delay: 200,
        easing: window.__easing
      },
      stage: "",
      customEasing: "easeInSine",
      customDuration: 3000
    };
  },
  computed: {
    ...mapState("carousel", [
      "vPageCardHeight",
      "carouselHeight",
      "carouselWidth",
      "transitionImage"
    ])
  },
  methods: {
    before_enter(el) {
      this.stage = "before_enter";

      if (this.name === "fade") {
        this.fade(el, this.stage);
      } else if (this.name === "slideRight") {
        this.slide_right(el, this.stage);
      } else {
        console.log("未知的动画名", this.name);
      }
    },
    async enter(el, done) {
      this.stage = "enter";
      if (this.name === "fade") {
        this.fade(el, this.stage);
        setTimeout(() => {
          done();
        }, 1000);
      } else if (this.name === "slideRight") {
        this.slide_right(el, this.stage);
        setTimeout(() => {
          done();
        }, 300);
      } else {
        console.log("未知的动画名", this.name);
      }
    },
    after_enter(el) {
      this.stage = "after_enter";

      if (this.name === "fade") {
        this.fade(el, this.stage);
      } else if (this.name === "slideRight") {
        this.slide_right(el, this.stage);
      } else {
        console.log("未知的动画名", this.name);
      }
    },
    before_leave(el) {
      this.stage = "before_leave";
      if (this.name === "fade") {
        this.fade(el, this.stage);
      } else if (this.name === "slideRight") {
        this.slide_right(el, this.stage);
      } else {
        console.log("未知的动画名", this.name);
      }
    },
    leave(el, done) {
      this.stage = "leave";
      if (this.name === "fade") {
        this.fade(el, this.stage);
        setTimeout(() => {
          done();
        }, 1000);
      } else if (this.name === "slideRight") {
        this.slide_right(el, this.stage);
        setTimeout(() => {
          done();
        }, 300);
      } else {
        console.log("未知的动画名", this.name);
      }
    },
    after_leave(el) {
      this.stage = "after_leave";
      if (this.name === "fade") {
        this.fade(el, this.stage);
      } else if (this.name === "slideRight") {
        this.slide_right(el, this.stage);
      } else {
        console.log("未知的动画名", this.name);
      }
    },
    // 淡入淡出
    fade(el, stage) {
      if (stage === "before_enter") {
        $(el).css("opacity", 0);
        $(el).addClass("beforeAnimate");
      } else if (stage === "enter") {
        $(el).css({
          opacity: 1,
          transition: `opacity 1s ease`
        });
        if (el.id === "home") {
          $(".h-c-bg").css({
            opacity: 1,
            transition: "opacity 1.6s ease"
          });
        }
      } else if (stage === "after_enter") {
        $(el).removeClass("beforeAnimate");
        el.offsetWidth;
        $("html, body").animate({ scrollTop: 1 }, 700);
      } else if (stage === "before_leave") {
        $(el).css({ opacity: 1 });
        $(el).addClass("beforeAnimate");
      } else if (stage === "leave") {
        $(el).css({
          opacity: 0,
          transition: `opacity 1s ease`
        });
      } else if (stage === "after_leave") {
        $(el)
          .removeClass("beforeAnimate")
          .attr("style", "");
      }
    },
    // 右侧滑出动画
    slide_right(el, stage) {
      // 进入
      if (stage === "before_enter") {
        $(el).addClass("beforeAnimate");
        $(el).css({
          transform: "translateX(100%)"
        });
        $("#app").append("<div class='v-transition-mask'/>");
        // 进入中
      } else if (stage === "enter") {
        $("#app .v-transition-mask").css({
          opacity: 1,
          transition: `opacity 0.3s ease`
        });
        el.offsetWidth;
        $(el).css({
          transform: "translateX(0%)",
          transition: `transform 0.3s ease`
        });
        // 进入后
      } else if (stage === "after_enter") {
        document.addEventListener("touchmove", this._preventDefault, {
          passive: false
        });
        // 离开前
      } else if (stage === "before_leave") {
        // 离开中
      } else if (stage === "leave") {
        $("#app .v-transition-mask").css({
          opacity: 0,
          transition: `opacity 0.3s ease`
        });

        $(el).css({
          transform: "translateX(100%)",
          transition: `transform 0.3s ease`
        });
        // 离开后
      } else if (stage === "after_leave") {
        $("#app .v-transition-mask").remove();
        document.removeEventListener("touchmove", this._preventDefault, {
          passive: false
        });
      }
    },
    // 左侧滑出动画
    slide_left(el, stage) {
      if (stage === "before_enter") {
        // $(el).addClass("beforeAnimate");
        $(el).css({
          display: "flex !important"
        });
        $("#app").append("<div class='v-transition-mask'/>");
        if (window.innerWidth >= 766) {
          $(el)
            .find(".home-menu")
            .css({
              opacity: "0"
            });
        }
      } else if (stage === "enter") {
      } else if (stage === "after_enter") {
        if (window.innerWidth >= 766) {
          $(el)
            .find(".home-menu")
            .css({
              transition: "all 0s"
            });
        }
        document.addEventListener("touchmove", this._preventDefault, {
          passive: false
        });
      } else if (stage === "before_leave") {
      } else if (stage === "leave") {
        $("#app .v-transition-mask").css({
          opacity: 0,
          transition: `opacity 0.3s ease`
        });
      } else if (stage === "after_leave") {
        $("#app .v-transition-mask").remove();
        document.removeEventListener("touchmove", this._preventDefault, {
          passive: false
        });
      }
    },
    mixing_fade(el, stage) {
      // 路由切换进入时
      if (stage === "before_enter") {
        $(el).addClass("beforeAnimate");
        $(el).css("opacity", 0);
      } else if (stage === "enter") {
        setTimeout(() => {
          $(el).css({
            opacity: 1,
            transition: `opacity 1s ease`
          });
        }, 600);
      } else if (stage === "after_enter") {
        $(el).removeClass("beforeAnimate");
      } else if (stage === "before_leave") {
        // 路由切换离开时
        $(el).css("opacity", 1);
      } else if (stage === "leave") {
      } else if (stage === "after_leave") {
        $(el)
          .removeClass("beforeAnimate")
          .attr("style", "");
      }
    },
    /**
     * 禁止页面默认事件
     * @param Function
     */
    _preventDefault(ev) {
      ev = ev || window.event;
      ev.preventDefault();
    }
  }
};
</script>
<style lang="scss">
.beforeAnimate {
  position: fixed !important;
  width: 40vw;
  // height: calc(100vh - 140px);
  height: 100vh;
  z-index: 90;
  top: 140px;
  left: auto !important;
  right: 0 !important;
  overflow: hidden !important;
  will-change: transform;
  transition: all 0.3s !important;
}

.home-menu-beforeAnimate {
  padding: 10px 41vw 10px 10px !important;
}
</style>
